var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contact"},[_c('div',{staticClass:"contact-title"},[_vm._v(_vm._s(_vm.section.treatment.more.contact.title))]),_c('div',{staticClass:"contact-text"},[_vm._v(_vm._s(_vm.section.treatment.more.contact.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }